import { createSlice, createAsyncThunk, type AsyncThunkOptions } from '@reduxjs/toolkit';
import services from 'services/services';

// Import types
import type { RootState } from 'store/store';
import type { WatchingBookmark, ProductWatchingTime } from 'types/api/bookmarks/watching';

const options: AsyncThunkOptions<void | string, { state: RootState }> = {
	condition: (_arg, { getState }) => {
		const state = getState();
		return Boolean(state.subscriber.details);
	}
};

export const fetchBookmarksWatching = createAsyncThunk(
	'watching/fetchBookmarksWatching',
	(uuid: string) => services.get<ProductWatchingTime>(`/subscriber/bookmarks/watching/${uuid}`).then((response) => response.data),
	options
);

export const fetchBookmarksWatchingUuids = createAsyncThunk(
	'watching/fetchBookmarksWatchingUuids',
	() => services.get<WatchingBookmark[]>('/subscriber/bookmarks/watching/uuids').then((response) => response.data),
	options
);

type State = {
	isLoading: boolean;
	isError: boolean;
	time: number;
	data: WatchingBookmark[];
};

const initialState: State = {
	isLoading: true,
	isError: false,
	time: 0,
	data: []
};

const watching = createSlice({
	name: 'watching',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchBookmarksWatching.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.time = 0;
		});
		builder.addCase(fetchBookmarksWatching.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.time = action.payload.time;
		});
		builder.addCase(fetchBookmarksWatching.rejected, (state) => {
			state.isLoading = false;
			state.isError = true;
		});
		builder.addCase(fetchBookmarksWatchingUuids.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
		});
		builder.addCase(fetchBookmarksWatchingUuids.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(fetchBookmarksWatchingUuids.rejected, (state) => {
			state.isLoading = false;
			state.isError = true;
		});
	}
});

export default watching.reducer;
